import { Component, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
import { ChangeDetectorRef } from '@angular/core';
import { LocalizationService } from '../../../Services/localization-service';
import { RouterModule } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-banner1-component',
  imports: [
    TranslatePipe,
    RouterModule
],
  templateUrl: './banner1-component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./banner1-component.scss']
})
export class Banner1Component implements OnInit {
  private readonly localizationService = inject(LocalizationService);
  private readonly cdr = inject(ChangeDetectorRef);

  currentLang = signal<string>(environment.defaultLang);


  ngOnInit(): void {
    this.localizationService.getLanguage().subscribe(lang => {
      this.currentLang.set(lang);
      this.cdr.detectChanges();
    });
  }
}
